// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__33FDx","title":"AfterBackImages_title__1XNum","images":"AfterBackImages_images__33soQ"};